// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React from "react";
import { NavLink } from "react-router-dom";
import { FontIcon, Link } from "@fluentui/react";
import ConditionalNavLink from "../common/conditionalNavLink/conditionalNavLink";
import { strings } from "../../../common/strings";
import "./sidebar.scss";
import { getCookieAdmin, getCookieRole } from "../common/jsonSchemaFormHelper";

/**
 * Side bar that remains visible throughout app experience
 * Contains links to editor, settings, export, etc.
 * @param param0 - {
 *      project - IProject
 * }
 */
export function Sidebar({ project, widgetMode }) {
    const projectId = project ? project.id : null;

    return (
        !getCookieAdmin() && (
            <div className="bg-lighter-2 app-sidebar" id="appSidebar">
                <ul>
                    {!widgetMode &&
                        (<React.Fragment>
                        <li>
                            <Link title={"Home"} href={`/`} exact role="button">
                                <FontIcon iconName="Home" />
                            </Link>
                            {/*<NavLink title={"Home"} to={`/`} exact role="button">*/}
                            {/*    <FontIcon iconName="Home" />*/}
                            {/*</NavLink>*/}
                        </li>                    
                        <li>
                            <ConditionalNavLink
                                disabled={!projectId}
                                title={strings.tags.editor}
                                to={`/projects/${projectId}/edit`}
                            >
                                <FontIcon iconName="Tag" />
                            </ConditionalNavLink>
                        </li>
                        <li>
                            <ConditionalNavLink
                                disabled={!projectId}
                                title={strings.train.title}
                                to={`/projects/${projectId}/train`}
                            >
                                <FontIcon iconName="MachineLearning" />
                            </ConditionalNavLink>
                        </li>
                            <li>
                                <ConditionalNavLink
                                    disabled={!projectId}
                                    title={`Model Compose`}
                                    to={`/projects/${projectId}/modelcompose`}
                                >
                                    <FontIcon iconName="Merge" />
                                </ConditionalNavLink>
                            </li>
                            <li>
                                <ConditionalNavLink
                                    disabled={!projectId}
                                    title={`Analyze`}
                                    to={`/projects/${projectId}/predict`}
                                >
                                    <FontIcon iconName="Insights" />
                                </ConditionalNavLink>
                            </li>                            
                        </React.Fragment>)
                    }
                    {/* <li>
                    <ConditionalNavLink
                        disabled={!projectId}
                        title={strings.projectSettings.title}
                        to={`/projects/${projectId}/settings`}
                    >
                        <FontIcon iconName="DocumentManagement" />
                    </ConditionalNavLink>
                </li> */}
                    {/* <li>
                    <NavLink
                        title={strings.connections.title}
                        to={`/connections`}
                        role="button"
                    >
                        <FontIcon iconName="Plug" />
                    </NavLink>
                </li> */}
                    { !widgetMode &&
                        (
                        <React.Fragment>
                            <li className="prebuilt-demo-sidebar-item">
                                <NavLink
                                    title={strings.prebuiltPredict.title}
                                    to={`/prebuilts-analyze`}
                                    role="button"
                                >
                                    <FontIcon iconName="ContactCard" />
                                </NavLink>
                            </li>
                            <li className="prebuilt-demo-sidebar-item">
                                <NavLink
                                    title={strings.layoutPredict.title}
                                    to={`/layout-analyze`}
                                    role="button"
                                >
                                    <FontIcon iconName="KeyPhraseExtraction" />
                                </NavLink>
                            </li>
                            <li className="prebuilt-demo-sidebar-item">
                                <NavLink
                                    title='Company Endpoints'
                                    to={`/company/upload-endpoints`}
                                    role="button"
                                >
                                    <FontIcon iconName="Settings" />
                                </NavLink>
                            </li>                            
                            { getCookieRole()?.includes('Admin') &&
                                <li>
                                    <NavLink
                                        title='Client Management'
                                        to={`/clientmanagement`}
                                        role="button"
                                    >
                                        <FontIcon iconName="AccountManagement" />
                                    </NavLink>                                
                                </li>
                            }                            
                        </React.Fragment>
                        )
                    }
                </ul>
                <div className="app-sidebar-fill"></div>
                {/* <ul> */}
                {/* <li>
                    <FontIcon
                        iconName="CollapseMenu"
                        style={{ cursor: "pointer", paddingBottom: "10px" }}
                    />
                </li> */}
                {/* <li>
                    <NavLink
                        title={strings.appSettings.title}
                        to={`/settings`}
                        role="button"
                    >
                        <FontIcon iconName="Settings" />
                    </NavLink>
                </li> */}
                {/* </ul> */}
            </div>
        )
    );
}
